@if (
  !(
    profile?.ekycStatus === EkycStatus.Verified || profile?.ekycStatus === EkycStatus.NotRequired
  ) ||
  !isEligibleToInvest ||
  !profile?.twoFactorEnabled
) {
  <div class="tw-mb-10 tw-rounded-lg tw-border tw-border-divider tw-p-8 tw-shadow">
    <h3 class="p-text-h3 tw-mb-1 tw-font-normal">
      {{ 'profile.onboardingChecklistTitle' | translate }} 👋
    </h3>
    <p class="p-text-p tw-mb-5">{{ 'profile.onboardingChecklistDescription' | translate }}</p>
    <ul class="checklist">
      <li class="checklist__item active">
        <div class="checklist__header">
          <div class="checklist__content">
            <span>{{ 'profile.onboardingChecklist1' | translate }}</span>
          </div>
        </div>
      </li>
      <li class="checklist__item" [class.active]="profile?.ekycStatus === EkycStatus.Verified">
        <div class="checklist__header">
          <div class="checklist__content max-sm:tw-flex-wrap" routerLink="/proceed-e-kyc">
            <span>{{ 'profile.onboardingChecklist2' | translate }}</span>
            @if (profile?.ekycStatus !== EkycStatus.Verified) {
              <button class="btn btn-green btn-sm">
                {{ 'profile.onboardingChecklist2Cta' | translate }}
              </button>
            }
          </div>
        </div>
      </li>
      <li class="checklist__item" [class.active]="isEligibleToInvest">
        <div
          class="checklist__header"
          (click)="!isEligibleToInvest && isErrorsExist() ? collapse.toggle() : null"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="collapseExample"
        >
          <div class="checklist__content">
            <span>{{
              (role === Role.IndividualInvestor
                ? 'profile.onboardingChecklist3'
                : 'profile.onboardingChecklist3b'
              ) | translate
            }}</span>
            @if (!isEligibleToInvest && isErrorsExist()) {
              <span class="checklist__icon">
                <p-icon name="chevron-down"></p-icon>
              </span>
            }
            <!-- In case like profile is complete, but Business Details are not complete, which makes user NOT eligible to invest -->
            @if (!isEligibleToInvest && !isErrorsExist() && role !== Role.IndividualInvestor) {
              <span>
                <a [routerLink]="['business-details']" class="btn btn-green btn-sm">
                  {{ 'profile.completeBusinessDetails' | translate }}
                </a>
              </span>
            }
          </div>
        </div>
        <div class="checklist_collapsible" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
          <div class="empty:tw-hidden">
            <app-validation-error-summary
              [form]="form"
              [additionalForms]="additionalForms"
              [formName]="'profileDetails'"
              [errorFilterFn]="errorFilterFn"
            >
            </app-validation-error-summary>
          </div>
        </div>
      </li>
      <li class="checklist__item active" [class.active]="profile?.twoFactorEnabled === true">
        <div class="checklist__header">
          <div
            class="checklist__content max-sm:tw-flex-wrap"
            routerLink="/profile/settings/security"
          >
            <span>{{ 'profile.onboardingEnable2fa' | translate }}</span>
            @if (!profile?.twoFactorEnabled) {
              <button class="btn btn-green btn-sm">
                {{ 'common.enable' | translate }}
              </button>
            }
          </div>
        </div>
      </li>
    </ul>
  </div>
}
